module.exports = __webpack_public_path__ + "img/dl3dvn-currency-guide-2.87623759.png";